export default class RouterConstants {
	public static readonly CONSOLE = {
		path: "",
		fullPath: "/",
	};

	public static readonly LICENSED_AI = {
		path: "licensed-AI",
		fullPath: "/licensed-AI",
	};

	public static readonly IMAGE_GENERATION = {
		path: "image-generation",
		fullPath: `${this.CONSOLE.path}/image-generation`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/image-generation/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/image-generation/api`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/image-generation/iframe`,
		},

		COMFYUI: {
			path: "comfy-ui",
			fullPath: `${this.CONSOLE.path}/image-generation/comfy-ui`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/image-generation/demo`,

			IMAGE_GENERATION: {
				path: "image-generation",
				fullPath: `${this.CONSOLE.path}/image-generation/demo/image-generation`,
			},

			TEXT_TO_VECTOR: {
				path: "text-to-vector",
				fullPath: `${this.CONSOLE.path}/image-generation/demo/text-to-vector`,
			},
		},
	};

	public static readonly IMAGE_EDITING = {
		path: "image-editing",
		fullPath: `${this.CONSOLE.path}/image-editing`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/image-editing/overview`,
		},
		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/image-editing/api`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/image-editing/iframe`,
		},

		COMFYUI: {
			path: "comfy-ui",
			fullPath: `${this.CONSOLE.path}/image-editing/comfy-ui`,
		},

		IMAGE: {
			DEMO: {
				path: "image",
				fullPath: `${this.CONSOLE.path}/image-editing/image/demo`,
			},
			path: "image",
			fullPath: `${this.CONSOLE.path}/image-editing/image`,
		},
		VIDEO: {
			path: "video",
			fullPath: `${this.CONSOLE.path}/image-editing/video`,
		},
		OBJECT_CONTENT_MANIPULATION: {
			path: "object-content-manipulation",
			fullPath: `${this.CONSOLE.path}/image-editing/object-content-manipulation`,
		},
		STYLE_ATMOSPHERE: {
			path: "style-atmosphere",
			fullPath: `${this.CONSOLE.path}/image-editing/style-atmosphere`,
		},
		BACKGROUND_COMPOSITION: {
			path: "background-composition",
			fullPath: `${this.CONSOLE.path}/image-editing/background-composition`,
		},
		RESTORATION_ENHANCEMENT: {
			path: "restoration-enhancement",
			fullPath: `${this.CONSOLE.path}/image-editing/restoration-enhancement`,
		},
	};

	public static readonly ADS_GENERATION = {
		path: "ads-generation",
		fullPath: `${this.CONSOLE.path}/ads-generation`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/ads-generation/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/ads-generation/api`,
		},

		BRANDS_TEMPLATES: {
			path: "brands-template",
			fullPath: `${this.CONSOLE.path}/ads-generation/brands-template`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/ads-generation/iframe`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/ads-generation/demo`,
			ADS_GENERATION: {
				path: "ads-generator",
				fullPath: `${this.CONSOLE.path}/ads-generation/demo/ads-generator`,
			},
			ADS_EDITOR: {
				path: "ads-editor",
				fullPath: `${this.CONSOLE.path}/ads-generation/demo/ads-editor`,
			},
			BRANDS_TEMPLATES_EDITOR: {
				path: "brands_templates-editor",
				fullPath: `${this.CONSOLE.path}/ads-generation/demo/brands_templates-editor`,
			},
		},
	};

	public static readonly PRODUCT_SHOT = {
		path: "product-shot",
		fullPath: `${this.CONSOLE.path}/product-shot`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/product-shot/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/product-shot/api`,
		},

		COMFY_UI: {
			path: "comfy-ui",
			fullPath: `${this.CONSOLE.path}/product-shot/comfy-ui`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/product-shot/demo`,
			PRODUCT_SHOT: {
				path: "product-shot",
				fullPath: `${this.CONSOLE.path}/product-shot/demo/product-shot`,
			},
		},
	};

	public static readonly VIDEO_EDITING = {
		path: "video-editing",
		fullPath: `${this.CONSOLE.path}/video-editing`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/video-editing/overview`,
		},
		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/video-editing/api`,
		},
		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/video-editing/demo`,
			VIDEO_GENERATION: {
				path: "video-generation",
				fullPath: `${this.CONSOLE.path}/video-editing/demo/video-generation`,
			},
		},
	};

	public static readonly WORKSPACE_SETTINGS = {
		path: "organization-settings",
		fullPath: `${this.CONSOLE.path}/organization-settings`,
		requiresOrg: true,
	};

	public static readonly CONSUMPTION_AND_BILLING = {
		path: "consumption-and-billing",
		fullPath: `${this.CONSOLE.path}/consumption-and-billing`,
		requiresOrg: true,
	};

	public static readonly FORGOT_PASSWORD = {
		path: "/forgot-password",
	};

	public static readonly MFA_TOTP_SETUP = {
		path: "/mfa_totp_setup",
	};

	public static readonly MFA_REVERT = {
		path: "/mfa_revert",
		fullPath: "/mfa_revert",
	};

	public static readonly SIGNUP = {
		path: "/register",
	};

	public static readonly LOGIN = {
		path: "/login",
	};
	public static readonly PRICING = {
		path: "/pricing",
		fullPath: "/pricing",
	};
	public static readonly MCP_AUTH = {
		path: "/mcp-auth",
	};
	public static readonly PLUGIN_AUTH = {
		path: "/plugin-login",
	};
	public static readonly PLUGIN_LOGIN_STATUS = {
		path: "/pluginAuth-status",
	};
	public static readonly USER_INFO = {
		path: "/user-info",
	};

	public static readonly AUTH = {
		path: "/auth",
	};

	public static readonly PASSWORD_RESET = {
		path: "/password-reset",
	};
	public static readonly ACCOUNT_VERIFICATION = {
		path: "/account-verification",
	};

	public static readonly MODELS = {
		path: "models",
		fullPath: `${this.CONSOLE.path}/models`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/models/overview`,
		},
		FOUNDATION: {
			path: "foundation",
			fullPath: `${this.CONSOLE.path}/models/foundation`,
		},
		AUXILIARY: {
			path: "auxiliary",
			fullPath: `${this.CONSOLE.path}/models/auxiliary`,
		},
		ATTRIBUTION_SERVICE: {
			path: "attribution-service",
			fullPath: `${this.CONSOLE.path}/models/attribution-service`,
		},
		KNOWLEDGE: {
			path: "knowledge",
			fullPath: `${this.CONSOLE.path}/models/knowledge`,
		},
	};

	public static readonly IFRAME = {
		path: "iframe",
		fullPath: `${this.CONSOLE.path}/iframe`,
		requiresOrg: true,
	};
	public static readonly NEW_IFRAMES = {
		path: "iframes-v2",
		fullPath: `${this.CONSOLE.path}/iframes-v2`,
		requiresOrg: true,
	};

	public static readonly NEW_TG = {
		path: "tailored-generation",
		fullPath: `${this.CONSOLE.path}/tailored-generation`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/tailored-generation/overview`,
		},

		PROJECTS: {
			path: "projects",
			fullPath: `${this.CONSOLE.path}/tailored-generation/projects`,
			viewPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId`,
			editPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/edit`,
			createPath: `${this.CONSOLE.path}/tailored-generation/projects/create`,
			requiresOrg: true,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/tailored-generation/api`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/tailored-generation/iframe`,
		},

		ACCESS_METHODS: {
			path: "access-methods",
			fullPath: `${this.CONSOLE.path}/tailored-generation/access-methods`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/tailored-generation/demo`,

			IMAGE_GENERATION: {
				path: "image-generation",
				fullPath: `${this.CONSOLE.path}/tailored-generation/demo/image-generation`,
			},
			IMAGE_EDITING: {
				path: "image-editing",
				fullPath: `${this.CONSOLE.path}/tailored-generation/demo/image-editing`,
			},
		},

		BEST_PRACTICES: {
			path: "best-practices",
			fullPath: `${this.CONSOLE.path}/tailored-generation/best-practices`,
		},
		FIGMA: {
			path: "figma",
			fullPath: `${this.CONSOLE.path}/tailored-generation/figma`,
		},

		MODELS: {
			path: "models",
			fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models`,
			viewPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/:modelId`,
			createPath: "models/create",
			createFullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/create`,
			requiresOrg: true,

			PLAYGROUND: {
				path: "playground",
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/:modelId/playground`,
				requiresOrg: true,
			},

			EVALUATION: {
				path: "evaluation",
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/:modelId?/evaluation`,
				requiresOrg: true,
			},

			DATASET: {
				path: "dataset",
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/:modelId/dataset/:datasetId`,
				requiresOrg: true,
			},
		},

		DATASETS: {
			path: "datasets",
			createPath: "datasets/create",
			createFullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets/create`,
			fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets`,
			viewPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets/:datasetId`,
			advancedViewPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets/:datasetId/advanced`,
			editPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets/:datasetId/edit`,
			requiresOrg: true,
		},

		// Legacy routing (same components for now)
		LEGACY: {
			PROJECTS: {
				path: "projects/legacy",
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy`,
				viewPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId`,
				createPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/create`,
			},
			MODELS: {
				path: "models",
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/models`,
				viewPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/models/:modelId`,
				createFullPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/models/create`,
				EVALUATION: {
					path: "evaluation",
					fullPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/models/:modelId?/evaluation`,
				},
				DATASET: {
					path: "dataset",
					fullPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/models/:modelId/dataset/:datasetId`,
				},
			},
			DATASETS: {
				path: "datasets",
				createFullPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/datasets/create`,
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/datasets`,
				viewPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/datasets/:datasetId`,
				advancedViewPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/datasets/:datasetId/advanced`,
				editPath: `${this.CONSOLE.path}/tailored-generation/projects/legacy/:projectId/datasets/:datasetId/edit`,
			},
			DEMO: {
				IMAGE_GENERATION: {
					path: "image-generation",
					fullPath: `${this.CONSOLE.path}/tailored-generation/demo/legacy/image-generation`,
				},
			},
		},
	};
	public static readonly AUTH_KEYS = {
		path: "api-keys",
		fullPath: `${this.WORKSPACE_SETTINGS.fullPath}/api-keys`,
		requiresOrg: true,
	};
	public static readonly USAGE_BILLING = {
		path: "usage",
		fullPath: `${this.CONSUMPTION_AND_BILLING.fullPath}/usage`,
		requiresOrg: true,
	};
	public static readonly USERS = {
		path: "users",
		fullPath: `${this.WORKSPACE_SETTINGS.fullPath}/users`,
		requiresOrg: true,
	};
	public static readonly RELATED_ORGANIZATIONS = {
		path: "related-organizations",
		fullPath: `${this.WORKSPACE_SETTINGS.fullPath}/related-organizations`,
		requiresOrg: true,
	};
	public static readonly IP_PROJECTS = {
		path: "IP-projects",
		fullPath: `${this.WORKSPACE_SETTINGS.fullPath}/IP-projects`,
		requiresOrg: true,
	};
	public static readonly MFA_SETTINGS_TAB = {
		path: "mfa_settings",
		fullPath: `${this.WORKSPACE_SETTINGS.fullPath}/mfa_settings`,
		requiresOrg: true,
	};
	public static readonly SUBSCRIPTION = {
		path: "subscription",
		fullPath: `${this.CONSUMPTION_AND_BILLING.fullPath}/subscription`,
		requiresOrg: true,
	};
	public static readonly ACCOUNT_IFRAMES = {
		path: "iframes",
		fullPath: `${this.WORKSPACE_SETTINGS.fullPath}/iframes`,
		requiresOrg: true,
	};
	public static readonly NEW_IFRAMES_EDITOR = {
		path: ":id",
		fullPath: `${this.ACCOUNT_IFRAMES.fullPath}/:id`,
		editPath: this.ACCOUNT_IFRAMES.fullPath,
		createPath: `${this.ACCOUNT_IFRAMES.fullPath}/new`,
		requiresOrg: true,
		private: true,
	};
	public static readonly AttributionReports = {
		path: "attribution-reports",
		fullPath: `${this.WORKSPACE_SETTINGS.fullPath}/attribution-reports`,
		requiresOrg: true,
	};
	public static readonly GENERATION_REPORT = {
		path: "generation-report",
		fullPath: `${this.AttributionReports.fullPath}/generation-report`,
		requiresOrg: true,
	};
	public static readonly CATALOG_REPORT = {
		path: "catalog-report",
		fullPath: `${this.AttributionReports.fullPath}/catalog-report`,
		requiresOrg: true,
	};
	public static readonly TOP_IMAGES = {
		path: "top-images",
		fullPath: `${this.AttributionReports.fullPath}/top-images`,
		requiresOrg: true,
	};
	public static readonly PARTNERS_EARNINGS = {
		path: "partners-earnings",
		fullPath: `${this.AttributionReports.fullPath}/partners-earnings`,
		requiresOrg: true,
	};
	public static readonly PAGE_NOT_FOUND = {
		path: "page-not-found",
		fullPath: "page-not-found",
	};
	public static readonly MOBILE_NOT_SUPPORTED_PAGE = {
		path: "mobile-not-supported",
		fullPath: "mobile-not-supported",
	};
	public static readonly USER_PROFILE = {
		path: "user-profile",
		fullPath: `${this.CONSOLE.path}/user-profile`,
	};
	public static readonly APPS = {
		path: "playground-hub",
		fullPath: `/playground-hub`,

		TG: {
			path: "tailored-generation",
			fullPath: "/playground-hub/tailored-generation",

			IMAGE: {
				path: "image",
				fullPath: "/playground-hub/tailored-generation/image",
			},
			VIDEO: {
				path: "video",
				fullPath: "/playground-hub/tailored-generation/video",
			},
		},
	};
	public static readonly LABS = {
		path: "labs",
		fullPath: `/labs`,
		FIBO: {
			path: "fibo",
			fullPath: "/labs/fibo",
		},
		FIBO_BBQ: {
			path: "fibo-bbq",
			fullPath: "/labs/fibo-bbq",
		},
		FIBO_2: {
			path: "fibo-2",
			fullPath: "/labs/fibo-2",
		},
		FIBO_LITE: {
			path: "fibo-lite",
			fullPath: "/labs/fibo-lite",
		},
		FIBO_EDIT: {
			path: "fibo-edit",
			fullPath: "/labs/fibo-edit",
		},
		VIDEO_EDITING: {
			path: "video-editing",
			fullPath: "/labs/video-editing",
		},
	};
	public static readonly OLD_APPS = {
		path: "apps",
		fullPath: `/apps`,
	};
	public static readonly TEXT_TO_IMAGE = {
		path: "image-generation",
		fullPath: `/${this.APPS.path}/image-generation`,
	};
	public static readonly TEXT_TO_VECTOR = {
		path: "text-to-vector",
		fullPath: `/${this.APPS.path}/text-to-vector`,
	};
	public static readonly IMAGE_TO_IMAGE = {
		path: "image-editing",
		fullPath: `/${this.APPS.path}/image-editing`,
	};
	public static readonly AI_EDITOR = {
		path: "ai-editor",
	};
	public static readonly PRODUCT_PLACEMENT = {
		path: "product-placement/generator",
		fullPath: `${this.APPS.path}/product-placement/generator`,
	};
	public static readonly PRODUCT_PLACEMENT_GALLERY = {
		path: "product-placement",
		fullPath: `${this.APPS.path}/product-placement`,
	};
	public static readonly ADS_EDITOR = {
		path: "ads-editor",
		fullPath: `/${this.APPS.path}/ads-editor`,
		editPath: `/${this.APPS.path}/ads-editor`,
	};

	public static readonly ADS_GENERATOR = {
		path: "ads-generator",
		fullPath: `/${this.APPS.path}/ads-generator`,
		editPath: `/${this.APPS.path}/ads-generator`,
	};
	public static readonly AUTOMOTIVE = {
		path: "/automotive",
	};

	public static readonly AUTOMOTIVE_EDITOR = {
		path: "/editor",
		fullPath: `${this.AUTOMOTIVE.path}/editor`,
	};

	public static readonly NEW_AUTOMOTIVE_PROJECT = {
		path: "/create",
		fullPath: `${this.AUTOMOTIVE.path}/create`,
	};
	public static readonly AUTOMOTIVE_PROJECTS = {
		path: "/projects",
		fullPath: `${this.AUTOMOTIVE.path}/projects`,
	};
	public static readonly AUTOMOTIVE_PROJECT = {
		path: `${this.AUTOMOTIVE.path}/projects`,
		fullPath: `${this.AUTOMOTIVE.path}/projects/:project_id`,
	};
	public static readonly AUTOMOTIVE_PROJECT_UPLOADED = {
		path: `/uploaded`,
		fullPath: `${this.AUTOMOTIVE.path}/projects/:project_id/uploaded`,
	};

	public static readonly AUTOMOTIVE_PROJECT_FAVORITES = {
		path: `/favorites`,
		fullPath: `${this.AUTOMOTIVE.path}/projects/:project_id/favorites`,
	};

	public static readonly AUTOMOTIVE_PROJECT_SESSION = {
		path: "/session",
		fullPath: `${this.AUTOMOTIVE_PROJECT.fullPath}/session/:session_id`,
	};
	public static readonly AUTOMOTIVE_PROJECT_SIMPLE_SESSION = {
		path: "/simple-session",
		fullPath: `${this.AUTOMOTIVE.path}/simple-session/`,
	};
}
